import { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import axios from "axios";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [staySignedIn, setStaySignedIn] = useState(false);
  const handleCheckboxChange = (e) => {
    setStaySignedIn(e.target.checked);
  };



  const successMessage = location.state?.successMessage || "";

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}api/user/login`,
        {
          useremail: formData.email,
          password: formData.password,
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      const { token, user } = response.data;

      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));
      window.dispatchEvent(new Event("storage"));
      navigate("/Dashboard");
      
    } catch (err) {
      console.error("Login Error:", err);
      setError(err.response?.data?.message || "Invalid email or password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div id="wrapper">
      <section className="signup-section login-section d-flex align-items-center py-5 py-md-0">
        <div className="container signup-container">
          <div className="row">
            {/* Left Side */}
            <div className="col-md-6 text-white d-flex align-items-center pe-md-5">
              <div className="pe-md-5 text-center text-md-start">
                <h1 className="fw-bold mb-4">Welcome back! Ready to log in and dive in?</h1>
                <p className="color858c95 ft-18 lh-27 inter">Sign in to unlock all features and manage your accout effortlessly.</p>
              </div> 
            </div>

            {/* Right Side */}
            <div className="col-md-6">
              <div className="form-container mt-5 mt-md-0 d-flex align-items-center justify-content-center">
                <div className="w-100">
                  <h2 className="fw-bold mb-4">Sign In</h2>

                  {/* Success Message */}
                  {successMessage && (
                    <div className="alert alert-success text-center" role="alert">
                      {successMessage}
                    </div>
                  )}

                  {/* Error Message */}
                  {error && (
                    <div className="alert alert-danger text-center" role="alert">
                      {error}
                    </div>
                  )}

                  <form onSubmit={handleSubmit}>
                    {/* Email Field */}
                    <div className="form-group">
                      <input
                        type="email"
                        className={`form-control ${formData.email ? "has-value" : ""}`}
                        id="email"
                        name="email"
                        placeholder=" "
                        autoComplete="new-email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="email">Email Address</label>
                    </div>

                    {/* Password Field */}
                    <div className="form-group">
                      <input
                        type="password"
                        className={`form-control ${formData.password ? "has-value" : ""}`}
                        id="password"
                        name="password"
                        autoComplete="new-password"
                        placeholder=" "
                        value={formData.password}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="password">Password</label>
                    </div>

                  <div className="d-flex justify-content-between align-items-center">
                      
                      <span className="stay-signed-in checkbox-container d-flex gap-3">
                        <input
                          id="persistent"
                          name="persistent"
                          type="checkbox"
                          checked={staySignedIn}
                          onChange={handleCheckboxChange}
                        />
                        <label for="persistent">Keep me sign in</label>
                      </span>

                      <div className="form-group my-3">
                        <Link to="/forgot-password" className="form-check-label ft-14 lh-24 fw-500 text-white">
                          Forget Password?
                        </Link>
                      </div>



                  </div>
                    

                    <button type="submit" className="btn btn-red ft-15 fw-600 w-100 my-3 py-3" disabled={loading}>
                      {loading ? "Signing In..." : "Sign In"} <i className="fa-solid fa-arrow-right ms-2"></i>
                    </button>

                    <p className="mt-3 ft-14 lh-24 text-center">
                      Just starting with I&P?  
                      <Link to="/PreSignup" className="Register-link" style={{ color: "red", marginLeft: "5px" }}>
                        Signup
                      </Link>
                    </p>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Login;